export enum EMedia {
  IMAGE = 'image',
  VIDEO = 'video',
}

export type MediaEntity = {
  position: number;
  title: string;
  alt: string;
  mediaUrl: string;
  mediaType: EMedia;
};
